import React, { useEffect } from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const Update = () => {

    const { id } = useParams();
    const { readData } = useEntityCrud('Branch/GetBranch?BranchId=' + id);
    const { addData: updateData } = useEntityCrud('Branch/UpdateBranch');
    const navigate = useNavigate();

    const initialValues = {
        title: '',
        address: '',
        phone: '',
        holdingId: ''
    };

    useEffect(() => {
        readData().then(({ data }) => {
            if (data.status)
                formik.setValues({
                    ...data.result
                });
            formik.setFieldValue(
                "logo",
                `https://petromah.sabinarya.com/service/${data.result.logo}`
            );
        });
    }, []);

    const validationSchema = Yup.object({
        title: Yup.string()
            .nullable(),
        holdingId: Yup.string()
            .nullable(),
        address: Yup.string()
            .min(10, 'طول آدرس وارد شده کوتاه است')
            .nullable(),
        phone: Yup.string().nullable()
    });

    const onSubmit = (values) => {
        debugger
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            id,
            title: values.title,
            address: values.address,
            phone: values.phone,
            holdingId: values.holdingId,
            logo: values.logo ? values.logo.split("base64,")[1] : "",
        };
        if(values.parentId)
            postedData.parentId = values.parentId;
        updateData(postedData).then(({ data }) => {
            debugger
            if (data.status) {
                toast.success('به روزرسانی شرکت زیر مجموعه با موفقیت انجام شد');
                return navigate('/branches');
            } else {
                window.location.reload(navigate('/branches'));
            }
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/branches', { replace: true });
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ویرایش شرکت زیر مجموعه</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik} isEditMode={true} />
            </div>
        </div>
    );
}

export default Update;